import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=524d977a&scoped=true&"
import script from "./LoginButton.vue?vue&type=script&lang=ts&"
export * from "./LoginButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=524d977a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d977a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('524d977a', component.options)
    } else {
      api.reload('524d977a', component.options)
    }
    module.hot.accept("./LoginButton.vue?vue&type=template&id=524d977a&scoped=true&", function () {
      api.rerender('524d977a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/header/LoginButton.vue"
export default component.exports